module.exports = __webpack_public_path__ + "img/video_call.45794e30.png";